import { LoadableAfterPaint } from '@confluence/loadable';

import { CopyLinkButtonPlaceholder } from '../src/copy-link/CopyLinkButtonPlaceholder';

export { PAGE_MODE } from '../src/copy-link/CopyLink';

export const CopyLinkButtonLoader = LoadableAfterPaint<any>({
	loader: async () => {
		return (
			await import(/* webpackChunkName: "loadable-CopyLinkButton" */ '../src/copy-link/CopyLink')
		).CopyLink;
	},
	loading: CopyLinkButtonPlaceholder,
});
